module.exports = __webpack_public_path__ + "static/media/Trash.f66d1a0f.svg";